import classNames from "classnames";
import * as React from "react";
import {  IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import {  FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerSubTitle, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TypeSelectorComponent } from "../../ui-props/common";
import { WidgetDesignerPillInput } from "../../pill-input/PillInput";
import { HeatMapUI, IHeatMapAxis, IHeatMapAxisType, IHeatMapCellStyle, IHeatMapReducer, IHeatMapUIProps, generateSampleHeatMapData } from "../../heatmap-ui/HeatMapUI";
import { NewColorButton } from "../../../templates/cards/radial-gauge/GuageProperty";
import { Checkbox, ColorPicker, Input, Label, Select, useEffectWithPolling } from "uxp/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataSourcePropertyEditor } from "../../ui-props/DataSourceProperty";
import { IDataSource, IDataSourceBinding, executeAndBind } from "../../data-source-picker/datasource";
import { bindContainerId, convertColor } from "../../../../util";
import { DropdownProperty } from "../../ui-props/DropdownProperty";
import { IRoundOffProperty, RoundOffPropertyEditor, roundOffValue } from "../../ui-props/RoundOffProperty";

interface IHeatMapProps {
	xAxis:IHeatMapAxis;
    yAxis:IHeatMapAxis;
    yAxisSecondary?:IHeatMapAxis;
    subYAxisEnabled: boolean;
    valueField: string;
    aggregation:'min' | 'max' | 'sum' |'count'|'average'|IHeatMapReducer;
    showCellLabels?: boolean;
	roundOff?:IRoundOffProperty;
	valueUnits: string;
    xAxisBackground?: string;
    xAxisForeground?: string;

    yAxisBackground?: string;
    yAxisForeground?: string;

    subYAxisBackground?: string;
    subYAxisForeground?: string;


    cellBorder?: boolean;
	cellStyle?:string;//'square'|'circle';
    cellBorderColor?: string;
    cellColors?:Array<{stopAt:number,color:string}>;
    emptyCellColor?: string;
}
interface IHeatMapFieldProps extends IHeatMapProps {
	fieldLabel: IFieldTitleProps;
	binding:IDataSourceBinding;
}


export const HeatMapPropertyEditor: React.FunctionComponent<IPropertyEditorProps<IHeatMapFieldProps>> = (props) => {
	const _props = props.uiProps;
	let datasources: IDataSource[] = props.parentUIProps?.datasources || [];

	return <><PropertyContainer>
		<PropertyContainerTitle>Appearance</PropertyContainerTitle>
		{/* <PropertyGroup>
			<PropertyGroupTitle>Background </PropertyGroupTitle>
			<Property>
				<PropertyTitle>Background Color</PropertyTitle>

				<CustomColorPicker color={_props.backgroundColor}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, backgroundColor: v })}
				/>

			</Property>
		</PropertyGroup> */}
		<PropertyGroup>
			<PropertyGroupTitle>Horizontal Axis Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Background</PropertyTitle>

				<CustomColorPicker color={_props.xAxisBackground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, xAxisBackground: v })}
				/>

			</Property>
			<Property>
				<PropertyTitle>Text</PropertyTitle>
				<CustomColorPicker color={_props.xAxisForeground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, xAxisForeground: v })}
				/>


			</Property>
		</PropertyGroup>
		<PropertyGroup>
			<PropertyGroupTitle>Vertical Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Background</PropertyTitle>

				<CustomColorPicker color={_props.yAxisBackground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, yAxisBackground: v })}
				/>
			</Property>
			<Property>
				<PropertyTitle>Text</PropertyTitle>

				<CustomColorPicker color={_props.yAxisForeground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, yAxisForeground: v })}
				/>

			</Property>
		</PropertyGroup>
		{_props.subYAxisEnabled &&
			<PropertyGroup>
			<PropertyGroupTitle>Secondary Vertical Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Background</PropertyTitle>

				<CustomColorPicker color={_props.subYAxisBackground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, subYAxisBackground: v })}
				/>
			</Property>
			<Property>
				<PropertyTitle>Text</PropertyTitle>

				<CustomColorPicker color={_props.subYAxisForeground}
					contextData={props.contextData}
					onChange={(v) => props.onChange({ ..._props, subYAxisForeground: v })}
				/>

			</Property>
		</PropertyGroup>
		}
		<PropertyGroup>
			<PropertyGroupTitle>Cell Border</PropertyGroupTitle>
			<Property>
				<Checkbox checked={_props.cellBorder}
				onChange={(b)=>props.onChange({..._props,cellBorder:b})}
				label="Enable cell borders"
				/>
				<CustomColorPicker color={_props.cellBorderColor}
				onChange={(c)=>props.onChange({..._props,cellBorderColor:c})}
				contextData={props.contextData}
				/>
			</Property>
			<Property>
				<PropertyTitle>Cell Style</PropertyTitle>
				<Property>
				<TypeSelectorComponent
					selected={_props.cellStyle || 'square'}
					onChange={s => {
						props.onChange({..._props,cellStyle:s});
					}}
					itemWidth="40px"
					iconStyles={{ height: '0px', width: "0px" }}
					types={[
						{ icon: '', label: "Square", value: 'square' },
						{ icon: '', label: "Circle", value: 'circle' },

					]} />
				</Property>
			</Property>
		</PropertyGroup>
		<PropertyGroup>
			<div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
				Cell Colors

				<NewColorButton
					onAddNew={(v) => {
						let _colors = _props?.cellColors || []
						_colors.push(v)
						props.onChange({ ..._props, cellColors: _colors });
					}}
				/>

			</div>

			<Property>


				<div className="wd-gauge-config-colors">

					{_props?.cellColors?.map((s, i) => {

						return <div className="row">
							<div className="color">
								<ColorPicker
									color={s?.color}
									onChange={(s) => {
										let newColors = _props.cellColors?.slice?.() || [];
										if (newColors?.[i]) {
											newColors[i].color = s;
										}
										props.onChange({ ..._props, cellColors: newColors });
									}}
									className='color-input'
									position='right'
								/>

							</div>
							<div className="stop-at">
								<Label className="up-to">Up to <span className="value">{s?.stopAt?.toString() || '0'}</span></Label>
							</div>

							<div className="close"
								onClick={() => {
									let _colors = _props?.cellColors || []
									_colors.splice(i, 1)

									props.onChange({ ..._props, cellColors: _colors });
								}}
							>
								<FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
							</div>
						</div>
					})}
				</div>

			</Property>
			<Property>
				<PropertyTitle>Empty Cell Color</PropertyTitle>
				<Property>
				<CustomColorPicker color={_props.emptyCellColor||'#EFEFEF'}
				contextData={props.contextData}
				onChange={(s)=>props.onChange({..._props,emptyCellColor:s})}
				/>
				</Property>
			</Property>
		</PropertyGroup>
	</PropertyContainer>
	<PropertyContainer>
		<PropertyContainerTitle>Axis</PropertyContainerTitle>
		<PropertyGroup>
			<PropertyGroupTitle>Horizontal Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Axis Type</PropertyTitle>
				<TypeSelectorComponent
					selected={_props.xAxis?.type || 'hour'}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.xAxis || {type:'dayofweek'};
						axis = {...axis,type:s as IHeatMapAxisType};
						props.onChange({..._props,xAxis:axis});
					}}
					itemWidth="40px"
					iconStyles={{ height: '0px', width: "0px" }}
					types={[
						{ icon: '', label: "Hour", value: 'hour' },
						{ icon: '', label: "Day", value: 'dayofweek' },
						{ icon: '', label: "Month", value: 'month' },
						{ icon: '', label: "Field", value: 'field' },
						{ icon: '', label: "Custom", value: 'custom' },

					]} />
			</Property>
			<Property>
				<PropertyTitle>Field</PropertyTitle>
				<WidgetDesignerPillInput
					// uiProps={props.parentUIProps}
					contextData={props.contextData}
					value={_props.xAxis?.field || ''}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.xAxis || {type:'dayofweek'};
						axis = {...axis,field:s};
						props.onChange({..._props,xAxis:axis});
					}}
					className="widget-designer-input"
				/>
			</Property>
		</PropertyGroup>
		<PropertyGroup>
			<PropertyGroupTitle>Vertical Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Axis Type</PropertyTitle>
				<TypeSelectorComponent
					selected={_props.yAxis?.type || 'hour'}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.yAxis || {type:'dayofweek'};
						axis = {...axis,type:s as IHeatMapAxisType};
						props.onChange({..._props,yAxis:axis});
					}}
					itemWidth="40px"
					iconStyles={{ height: '0px', width: "0px" }}
					types={[
						{ icon: '', label: "Hour", value: 'hour' },
						{ icon: '', label: "Day", value: 'dayofweek' },
						{ icon: '', label: "Month", value: 'month' },
						{ icon: '', label: "Field", value: 'field' },
						{ icon: '', label: "Custom", value: 'custom' },

					]} />
			</Property>
			<Property>
				<PropertyTitle>Field</PropertyTitle>
				<WidgetDesignerPillInput
					// uiProps={props.parentUIProps}
					contextData={props.contextData}
					value={_props.yAxis?.field || ''}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.yAxis || {type:'dayofweek'};
						axis = {...axis,field:s};
						props.onChange({..._props,yAxis:axis});
					}}
					className="widget-designer-input"
				/>
			</Property>
		</PropertyGroup>
		<PropertyGroup>
			<PropertyGroupTitle>Secondary Vertical Axis</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Enable Secondary Axis</PropertyTitle>
				<Checkbox checked={_props.subYAxisEnabled}
				label="Enable secondary axis"
				onChange={(b)=>{
					props.onChange({..._props,subYAxisEnabled:b});
				}}
				/>
			</Property>
			{_props.subYAxisEnabled && <Property>
				<PropertyTitle>Axis Type</PropertyTitle>
				<TypeSelectorComponent
					selected={_props.yAxisSecondary?.type || 'field'}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.yAxisSecondary || {type:'field'};
						axis = {...axis,type:s as IHeatMapAxisType};
						props.onChange({..._props,yAxisSecondary:axis});
					}}
					itemWidth="40px"
					iconStyles={{ height: '0px', width: "0px" }}
					types={[
						{ icon: '', label: "Hour", value: 'hour' },
						{ icon: '', label: "Day", value: 'dayofweek' },
						{ icon: '', label: "Month", value: 'month' },
						{ icon: '', label: "Field", value: 'field' },
						{ icon: '', label: "Custom", value: 'custom' },

					]} />
			</Property>}
			{_props.subYAxisEnabled && <Property>
				<PropertyTitle>Field</PropertyTitle>
				<WidgetDesignerPillInput
					// uiProps={props.parentUIProps}
					contextData={props.contextData}
					value={_props.yAxisSecondary?.field || ''}
					onChange={s => {
						let axis:IHeatMapAxis = _props?.yAxisSecondary || {type:'field'};
						axis = {...axis,field:s};
						props.onChange({..._props,yAxisSecondary:axis});
					}}
					className="widget-designer-input"
				/>
			</Property>}
		</PropertyGroup>
	</PropertyContainer>
		<PropertyContainer>
			<PropertyContainerTitle>Data</PropertyContainerTitle>

			<DataSourcePropertyEditor
				binding={_props.binding}
				context={props.uxpContext}
				onChange={(binding) => props.onChange(Object.assign({}, _props, { binding }))}
				onChangeAny={(p, v) => {
					props.onChangeAny(p, v);
				}}
				containerId={props.containerId}
				sources={datasources}
				target={'dictionary-array'}
				title='Data Source'
				contextData={props.contextData}
				className='uxp-designer-data-source-selector'
				designer={props.designer}
			/>
			<PropertyGroup>
				<PropertyGroupTitle>Cell Value</PropertyGroupTitle>
			<Property  id={bindContainerId('value-field', props.containerId)}>
				<PropertyTitle>Value Field</PropertyTitle>
				<WidgetDesignerPillInput
					// uiProps={props.parentUIProps}
					contextData={props.contextData}
					value={_props.valueField || ''}
					onChange={s => {
						props.onChange({..._props,valueField:s});
					}}
					className="widget-designer-input"
				/>
			</Property>
			<Property>
					<PropertyTitle>Aggregation</PropertyTitle>
					<Select
                            
                            options={[
								{ label:'Sum',value:'sum'},
								{ label:'Average',value:'average'},
								{ label:'Min',value:'min'},
								{ label:'Max',value:'max'},
								{ label:'Count',value:'count'},
							]}
                            labelField={"label"}
                            valueField={"value"}
                            onChange={(s)=>props.onChange({..._props,aggregation:s as ('min'|'max'|'sum'|'count'|'average')})}
                            selected={_props.aggregation + ''}
                        />
			</Property>
			{
				RoundOffPropertyEditor({roundOff:_props.roundOff||{integer:false,decimalPoints:2},onChange:(r)=>{
					props.onChange({..._props,roundOff:r});
				}})
			}
			<Property>
				<PropertyTitle>Units</PropertyTitle>
				<Input value={_props.valueUnits} onChange={(txt)=>props.onChange({..._props,valueUnits:txt})} />
			</Property>
			</PropertyGroup>
			

	</PropertyContainer>
		<PropertyContainer>
			<PropertyContainerTitle>Field Properties</PropertyContainerTitle>
		<FieldProperty uiProps={_props} onChange={props.onChange} />
		</PropertyContainer>
</>;
}


export const Field: React.FunctionComponent<IUIFieldProps<IHeatMapFieldProps>> = (props) => {
	let data:any[] = [];
	const [loading,setLoading] = React.useState(false);
	const [chartData,setChartData] = React.useState<any[]>([]);

	
	function loadData() {
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            let data = generateSampleHeatMapData();
            setChartData(data);
            return
        }
		let binding = props.fieldProps.binding;
        if (!binding) {
            console.error('No binding for heatmap field',props.fieldProps);
            return;
        }
        setLoading(true)
        let params: any = { filters: props.contextData?.filters || {} }

        executeAndBind(props.uxpContext, binding, props.uiProps.datasources, params, props.contextData)
            .then(res => {
             
                setChartData(res)
            })
            .catch(e => {
                setChartData([])
                console.log('error getting data', e)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    useEffectWithPolling(props.uxpContext,  "heatmap/1",  60000, async () => {

		loadData();

}, [props.designer, props.uiProps, props.contextData]);
	return (
		<div className={classNames('ui-field-map-ui ui-field', props.mode)} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />

			<HeatMapUI 
				uxpContext={props.uxpContext}
				contextData={props.contextData}
				data={chartData}
				cellFormatter={(v)=> {
					if (v==null || typeof v == 'undefined') return '';
					var x =  roundOffValue(v,props.fieldProps.roundOff).toString();
                    if (props.fieldProps.valueUnits) x += props.fieldProps.valueUnits;
                    return x;
				}}
				aggregation={props.fieldProps.aggregation}
				subYAxisEnabled={props.fieldProps.subYAxisEnabled}
				cellBorder={props.fieldProps.cellBorder}
				cellStyle={props.fieldProps.cellStyle as (IHeatMapCellStyle)}
				cellBorderColor={convertColor(props.fieldProps.cellBorderColor,props.contextData)}
				cellColors={props.fieldProps.cellColors.map((c)=>({...c,color:convertColor(c.color,props.contextData)}))}
				emptyCellColor={convertColor(props.fieldProps.emptyCellColor,props.contextData)}
				showCellLabels={props.fieldProps.showCellLabels}
				subYAxisBackground={convertColor(props.fieldProps.subYAxisBackground,props.contextData)}
				subYAxisForeground={convertColor(props.fieldProps.subYAxisForeground,props.contextData)}
				valueField={props.fieldProps.valueField}
				xAxis={props.fieldProps.xAxis}
				yAxis={props.fieldProps.yAxis}
				xAxisBackground={convertColor(props.fieldProps.xAxisBackground,props.contextData)}
				xAxisForeground={convertColor(props.fieldProps.xAxisForeground,props.contextData)}
				yAxisBackground={convertColor(props.fieldProps.yAxisBackground,props.contextData)}
				yAxisForeground={convertColor(props.fieldProps.yAxisForeground,props.contextData)}
				yAxisSecondary={props.fieldProps.yAxisSecondary}

			/>
		</div >
	)
}
registerUIField({
	id:'heatmap',
	description:'Heatmap',
	field:Field,
	isInputField: false,
	propertyEditor:HeatMapPropertyEditor,
	defaultProps:{
		binding:null,
		aggregation:'average',
		fieldLabel:{},
		subYAxisEnabled:false,
		valueField:'',
		xAxis:{type:'hour',field:'{$.row.time}'},
		yAxis:{type:'dayofweek',field:'{$.row.time}'},
		cellBorder:true,
		cellBorderColor:'#EFEFEF',
		cellColors:[],
		valueUnits:'',
	}
})

// registerUIField({
// 	id: 'heatmap',
// 	description: 'Heatmap',
// 	field: Field,
// 	isInputField: true,
// 	propertyEditor: HeatMapropertyEditor,
// 	defaultProps: {
// 		datasources:[],
// 		fieldLabel: {
// 			label: '',
// 		},
// 		appearance:{showGrid:true,showYAxis:true,showLegend:false,stackBars:true},
// 		chartItems:[],
// 		refreshInterval:'120000',
// 		sortData:{isTimeSeriesData:false,sortBy:'none',sortOrder:'asc'},
// 		timeseries:false,
// 		xField:'',
		
// 	},
// 	type: 'position',


// });


